import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { AmbassadorEmailLoginComponent } from './app/components/angular-elements/ambassador-email-login/ambassador-email-login.component';
import { createCustomElement } from '@angular/elements';
import { AmbassadorVehicleListComponent } from './app/components/angular-elements/ambassador-vehicle-list/ambassador-vehicle-list.component';
import { AmbassadorReservationComponent } from './app/components/angular-elements/ambassador-reservation/ambassador-reservation.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = function (): void { };
  window.console.table = function (): void { };
  window.console.debug = function (): void { };
  window.console.warn = function (): void { };
  window.console.info = function (): void { };
}

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideAnimationsAsync(),
  ],
}).then(appRef => {
  // Registramos el web component
  const ambassadorEmailLoginElement = createCustomElement(AmbassadorEmailLoginComponent, {
    injector: appRef.injector
  });
  const ambassadorVehicleListElement = createCustomElement(AmbassadorVehicleListComponent, {
    injector: appRef.injector
  });
  const ambassadorReservationElement = createCustomElement(AmbassadorReservationComponent, {
    injector: appRef.injector
  });

  // Nombre de la etiqueta que podrán usar tus HTML dinámicos
  customElements.define('ambassador-email-login', ambassadorEmailLoginElement);
  customElements.define('ambassador-vehicle-list', ambassadorVehicleListElement);
  customElements.define('ambassador-reservation', ambassadorReservationElement);
}).catch((err) => console.error(err));
